import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import {
  setTrk,
  TrkTag,
  TrkElement,
} from '@nerdwallet/nw-client-lib/trk-helper';
import uuid from 'uuid/v4';

import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';
import { Impression } from '@nerdwallet/analytics/react/impression';
import ExpandMore from '@nerdwallet/react-icon/material/ExpandMore';
import { Box, Title, Select } from '@nerdwallet/currency';
import data from '../data/2022/award-categories';

import './awards-hero-select.less';

const handleDefaultValue = (selectedState, selectedProp) => {
  if (!selectedState.value) {
    const current = data.find((item) => item.value === selectedProp);
    if (current) {
      return current.label;
    }
  }
  return 'Select an option';
};

const HeroSelect = ({
  selected,
  colorStyle,
  layout,
  headingSize,
  shouldTrack,
}) => {
  const [open, setOpen] = useState(false);
  const [selectedState, setSelectedState] = useState({});

  const nodeId = uuid();
  const [trkId] = useState(nodeId);

  const elementImpressionProps = {
    id: `awards-hero-${trkId}`,
    elementName: 'AwardsHero',
  };

  const isAnchorLink = (url) => (url || '').charAt(0) === '#';
  const getModifiedUrl = (linkUrl, currentOption) =>
    isAnchorLink(linkUrl)
      ? linkUrl
      : linkUrl &&
        setTrk({
          url: linkUrl,
          params: {
            [TrkTag.location]: 'AwardsHero',
            [TrkTag.element]: TrkElement.hyperlink,
            [TrkTag.copy]: currentOption.value?.toLowerCase(),
            [TrkTag.sectionCategory]: 'AwardsHero--hero',
          },
        });

  useEffect(() => {
    const initialSelected = data.find((item) => item.value === selected);
    if (initialSelected) {
      setSelectedState(initialSelected);
    }
  }, [selected]);

  const handleSelectOption = (option) => {
    const current = data.find((item) => item.value === option);
    setSelectedState(current);
    setOpen(false);
    const modifiedUrl = getModifiedUrl(option, current.label);
    const url = shouldTrack ? modifiedUrl : option;
    window.location.href = url;
  };

  const defaultValue = handleDefaultValue(selectedState, selected);
  let boxStyle = colorStyle;

  if (colorStyle?.color) {
    boxStyle = {
      ...colorStyle,
      borderColor: colorStyle.color,
    };
  }

  const dropdownOutput = (
    <Box className="awards-hero__select-wrapper">
      {!_.isEmpty(selectedState) && (
        <React.Fragment>
          <Select
            onBlur={() => setOpen(false)}
            onClick={() => setOpen(!open)}
            onChange={(e) => handleSelectOption(e.target.value)}
            className="awards-hero__select-input"
            aria-hidden="true"
            value={selectedState.value || defaultValue}
            options={data}
            label="Categories list"
          />
          <Box
            component="output"
            style={boxStyle}
            border="2"
            className={classNames(['awards-hero__select', `${layout}`])}
            aria-expanded={open}
          >
            <Box style={colorStyle}>
              <Title
                component="h1"
                size={headingSize}
                className="awards-hero__select-title"
              >
                {selectedState.label || defaultValue}
              </Title>
            </Box>
            <ExpandMore />
          </Box>
        </React.Fragment>
      )}
    </Box>
  );

  const dropdownWithTrk = (
    <Impression eventType="element_impression" entityName="awards_hero">
      <ElementImpression {...elementImpressionProps}>
        {dropdownOutput}
      </ElementImpression>
    </Impression>
  );

  const dropdown = shouldTrack ? dropdownWithTrk : dropdownOutput;

  return dropdown;
};

HeroSelect.propTypes = {
  selected: PropTypes.string,
  colorStyle: PropTypes.string,
  layout: PropTypes.string,
  headingSize: PropTypes.string,
  shouldTrack: PropTypes.bool,
};

export default HeroSelect;
